import React from 'react';

export const DrawerContext = React.createContext({ footerRef: null, onClose: null });
